<div class="absence-panel" role="group" [attr.aria-label]="'squad.absence.editFor' | translate: { name: name }">
    <div class="panel-head">
        <p class="panel-title">{{ 'squad.absence.panel.title' | translate: { name: name } }}</p>
        <button
            type="button"
            class="panel-close"
            [attr.aria-label]="'squad.absence.panel.close' | translate"
            (click)="closed.emit()">
            <i-feather name="x" aria-hidden="true"></i-feather>
        </button>
    </div>
    <p class="panel-hint">{{ 'squad.absence.panel.hint' | translate }}</p>

    <div class="reasons">
        @for (option of reasons; track option) {
            <button
                type="button"
                class="reason"
                [class.selected]="reason === option"
                [attr.aria-pressed]="reason === option"
                (click)="setReason(option)">
                <i-feather [name]="reasonIcons[option]" aria-hidden="true"></i-feather>
                {{ 'squad.absence.reasons.' + option | translate }}
            </button>
        }
    </div>

    <div class="panel-foot">
        <label class="until-field">
            <span>{{ 'squad.absence.panel.untilLabel' | translate }}</span>
            <input type="date" [min]="day" [value]="draftUntil" (change)="setUntil($any($event.target).value)" />
        </label>
        @if (reason) {
            <button type="button" class="link-button" (click)="clear()">
                {{ 'squad.absence.panel.clear' | translate }}
            </button>
        }
    </div>

    @if (error) {
        <p class="panel-error" role="alert">{{ 'squad.absence.panel.error' | translate }}</p>
    }
</div>
